import moment from 'moment';

export const getRoundUpXmin = (roundMin, time) => {
  const theTime = time ? time : new Date();
  const roundedUp = Math.ceil(moment(theTime).minute() / roundMin) * roundMin;
  const roundedTime = moment(theTime).minute(roundedUp).second(0);
  return roundedTime.toDate();
};
